import React, { FC, useEffect, useState } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { ProClientL1Icon } from '@fiverr-private/visuals';

export interface CompanyLogoProps {
    logoUrl?: string;
    name: string;
    size?: number;
}

export const CompanyLogo: FC<CompanyLogoProps> = ({ logoUrl, name, size = 48 }) => {
    const [failedToLoad, setFailedToLoad] = useState(false);

    useEffect(() => {
        setFailedToLoad(false);
    }, [logoUrl]);

    return logoUrl && !failedToLoad ? (
        <Image
            height={`${size}px`}
            width={`${size}px`}
            borderRadius="sm"
            alt={name.replace(' ', '_')}
            src={logoUrl}
            onError={() => setFailedToLoad(true)}
        />
    ) : (
        <Stack height={`${size}px`} width={`${size}px`} backgroundColor="grey_300" borderRadius="sm" flexShrink={0}>
            <Stack margin="auto">
                <ProClientL1Icon />
            </Stack>
        </Stack>
    );
};
